import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap"
import ESpinner from "components/others/Spinner";
import ObjectcardInfo from "./ObjectCardInfo";
import ObjectCardTabs from "./ObjectCardTabs";
import ObjectCardToolBar from "./ObjectCardToolBar";
import { OffClientInfo } from 'modules/client';
import { OffTasks } from 'modules/task';
import { ObjectCardProvider, useObjectCard } from "./context/ObjectCardProvider";
import ObjectStatusIcon from "../ObjectsList/ObjectStatus/ObjectStatusIcon";
import { useGlobal } from "context/GlobalContext";
import SpinnerBlock from "components/others/SpinnerBlock";
import vconst from "utils/helpers/structs/vconst";
import useStatusObject from "./hooks/hookStatusObject";
import * as apiObject from "api/apiObjects";
import { useTranslation } from "react-i18next";
import useChangeDate from "hooks/useChangeDate";
import { useToast } from "context/ToastContext";
import { useSettings } from "context/SettingsContext";
import { DateTime as DT } from "luxon";
import ObjectVat from "../ObjectsList/ObjectVat/ObjectVat";

 
const ObjectCard = () => {

    const { g } = useGlobal();
    const { t } = useTranslation(['Objects']);
    const { showToast } = useToast();
    const { getSettings } = useSettings();
    const { changeDate } = useChangeDate();
    const { objectId, vObject, fetchObject, showSpinner, setShowSpinner, showAnalytics, isEditLocked } = useObjectCard();
    const [ clientInfoId, setClientInfoId] = useState(null);
    const [ showTasks, setShowTasks ] = useState(false);
    const { statusObjectFinished, statusObjectReject, statusObjectOpen } = useStatusObject();
    const [ priceSummary, setPriceSummary ] = useState(0);

    const dt = DT.fromMillis(vObject?.object?.objectFinished||0).toLocaleString(DT.DATE_MED);
    

    useEffect(()=>{
        fetchObject(); 
    },[objectId, g.target])

    
    const handleChangeStatus = async (statusData) => {
        setShowSpinner(true)
        const resStatus = await apiObject.setStatus(vObject.object.ID, statusData);
        if (resStatus?.errCode === 'RESERV_WAREHOUSE_NOT_EMPTY') {
            const messKey = statusData?.status === vconst.objectReject
                ? 'messReservWarehouseNotEmptyCancel'
                : 'messReservWarehouseNotEmptyFinished';
            showToast(t(messKey), 'danger');
        } else if (!resStatus?.stat) {
            showToast(t('common:messError'), 'danger');
        } else {
            if (statusData?.status === vconst.objectFinished) {
                showToast(t('messObjectFinished'), 'success');
            } else if (statusData?.status === vconst.objectReject) {
                showToast(t('messObjectCancel'), 'success');
            }
            if ([vconst.objectFinished, vconst.objectReject, vconst.objectPanding].includes(statusData?.status)) {
                // Оновлюємо список складів для сайдбару (резерв зникає/з'являється)
                await getSettings();
            }
        }
        await fetchObject();
    }    

    const handleClickDate = async (newFinishedDate) => {
        setShowSpinner(true) 
        const resDate = await apiObject.setFinished(vObject.object.ID, newFinishedDate);
        await fetchObject();
        if (!resDate) showToast(t('common:messError'), 'danger');        
    }
    

    return (<>
        <OffClientInfo
            clientId={clientInfoId}
            setClientId={setClientInfoId}/>

        <OffTasks
            show={showTasks}
            onHide={() => setShowTasks(false)}
            objectId={vObject?.object?.ID ?? null}
            contextName={vObject?.object?.objectName || vObject?.object?.clientName || null}/>

            <Row> 
                <Col className="col-sticky" sm={12}>
                    <div className="object-card__header">
                        <div className="object-card__identity">
                            <div className="object-card__title-row">
                                <h4
                                    className="object-card__title text-truncate"
                                    title={vObject?.object?.objectName || vObject?.object?.clientName || ''}
                                >
                                    {vObject?.object?.objectName || vObject?.object?.clientName}
                                </h4>
                                <div className="object-card__badges">
                                    <span className={
                                            ([vconst.objectFinished, vconst.objectReject].includes(vObject?.object?.objectStatus)
                                                && !(isEditLocked && vObject?.object?.objectStatus === vconst.objectFinished))
                                                ? 'cursor-pointer'
                                                : ''
                                        }
                                        onClick={(e)=>{
                                            const status = vObject?.object?.objectStatus;
                                            if (![vconst.objectFinished, vconst.objectReject].includes(status)) return;
                                            if (status === vconst.objectFinished && isEditLocked) return;
                                            if (e.ctrlKey)
                                                changeDate(vObject?.object?.objectFinished, handleClickDate)
                                            else statusObjectOpen(handleChangeStatus);
                                        }}>
                                        <ObjectStatusIcon status={vObject?.object?.objectStatus} 
                                            objectFinished={vObject?.object?.objectStatus === vconst.objectFinished ? dt : null}/>
                                    </span>
                                    <ObjectVat isVat={vObject?.object?.objectVat}/>
                                </div>
                            </div>
                            <span className="object-card__team">{vObject?.object?.teamName}</span>
                        </div>
                        <div className="object-card__toolbar">
                            <ObjectCardToolBar  
                                handleChangeStatus={handleChangeStatus}
                                setClientInfoId={setClientInfoId}
                                onShowTasks={() => setShowTasks(true)}/>
                        </div>
                    </div>
                </Col>

                {vObject?.object 
                ? (<>
                    <Col xl={showAnalytics ? 8 : 12} xxl={showAnalytics ? 9 : 12} className="pb-3">   
                        <ObjectCardTabs/> 
                    </Col>

                    {showAnalytics ? (
                        <Col xl={4} xxl={3}> 
                            <ObjectcardInfo
                                priceSummary={priceSummary}
                                setPriceSummary={setPriceSummary}/> 
                        </Col>
                    ) : null}
                </>)

                : (<Col className="py-3"><ESpinner show={true}/></Col>)}

            </Row>
        </>)
}

export default ObjectCard;